"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelSortType = exports.ShareMethod = exports.Channel = exports.Language = void 0;
// 语种
var Language;
(function (Language) {
    // 英文
    Language["EN"] = "en";
    // 简体
    Language["SC"] = "sc";
    // 繁体
    Language["TC"] = "tc";
    // 日语
    Language["JP"] = "jp";
})(Language || (exports.Language = Language = {}));
// 应用列表
var Channel;
(function (Channel) {
    // 系统分享
    Channel["SYSTEM"] = "system";
    // reddit
    Channel["REDDIT"] = "reddit";
    // fb
    Channel["FACEBOOK"] = "facebook";
    // telegram
    Channel["TELEGRAM"] = "telegram";
    // 小红书
    Channel["XIAOHONGSHU"] = "xiaohongshu";
    // tw
    Channel["TWITTER"] = "twitter";
    // ins
    Channel["INSTAGRAM"] = "instagram";
    // 微信
    Channel["WECHAT"] = "wechat";
    // 微信朋友圈
    Channel["WECHAT_MOMENTS"] = "wechatMoments";
})(Channel || (exports.Channel = Channel = {}));
// 分享方式
var ShareMethod;
(function (ShareMethod) {
    ShareMethod["SYSTEM_PANEL"] = "system_panel";
    ShareMethod["IMAGE_DIRECT"] = "image_direct";
    ShareMethod["TO_HOME"] = "to_home"; // 跳转到首页
})(ShareMethod || (exports.ShareMethod = ShareMethod = {}));
// 排序方式
var ChannelSortType;
(function (ChannelSortType) {
    ChannelSortType["CUSTOM"] = "custom";
    ChannelSortType["APP"] = "app"; // 用户已安装的App靠前
})(ChannelSortType || (exports.ChannelSortType = ChannelSortType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsS0FBSztBQUNMLElBQVksUUFTWDtBQVRELFdBQVksUUFBUTtJQUNoQixLQUFLO0lBQ0wscUJBQVMsQ0FBQTtJQUNULEtBQUs7SUFDTCxxQkFBUyxDQUFBO0lBQ1QsS0FBSztJQUNMLHFCQUFTLENBQUE7SUFDVCxLQUFLO0lBQ0wscUJBQVMsQ0FBQTtBQUNiLENBQUMsRUFUVyxRQUFRLHdCQUFSLFFBQVEsUUFTbkI7QUFFRCxPQUFPO0FBQ1AsSUFBWSxPQW1CWDtBQW5CRCxXQUFZLE9BQU87SUFDZixPQUFPO0lBQ1AsNEJBQWlCLENBQUE7SUFDakIsU0FBUztJQUNULDRCQUFpQixDQUFBO0lBQ2pCLEtBQUs7SUFDTCxnQ0FBcUIsQ0FBQTtJQUNyQixXQUFXO0lBQ1gsZ0NBQXFCLENBQUE7SUFDckIsTUFBTTtJQUNOLHNDQUEyQixDQUFBO0lBQzNCLEtBQUs7SUFDTCw4QkFBbUIsQ0FBQTtJQUNuQixNQUFNO0lBQ04sa0NBQXVCLENBQUE7SUFDdkIsS0FBSztJQUNMLDRCQUFpQixDQUFBO0lBQ2pCLFFBQVE7SUFDUiwyQ0FBZ0MsQ0FBQTtBQUNwQyxDQUFDLEVBbkJXLE9BQU8sdUJBQVAsT0FBTyxRQW1CbEI7QUFFRCxPQUFPO0FBQ1AsSUFBWSxXQUlYO0FBSkQsV0FBWSxXQUFXO0lBQ25CLDRDQUE2QixDQUFBO0lBQzdCLDRDQUE2QixDQUFBO0lBQzdCLGtDQUFtQixDQUFBLENBQUMsUUFBUTtBQUNoQyxDQUFDLEVBSlcsV0FBVywyQkFBWCxXQUFXLFFBSXRCO0FBRUQsT0FBTztBQUNQLElBQVksZUFHWDtBQUhELFdBQVksZUFBZTtJQUN2QixvQ0FBaUIsQ0FBQTtJQUNqQiw4QkFBVyxDQUFBLENBQUMsY0FBYztBQUM5QixDQUFDLEVBSFcsZUFBZSwrQkFBZixlQUFlLFFBRzFCIn0=